import { StorageKey } from '@uturn/portal/utils/storage-keys';
import { z } from '@uturn/portal/zod';

export type BannerDismissRecord = {
	dismissedAtMs: number;
	expiresAtMs: number;
};

const BannerDismissRecordSchema = z.object({
	dismissedAtMs: z.number().finite().nonnegative(),
	expiresAtMs: z.number().finite().nonnegative(),
});

// Local end of day time to live in ms.
const getMsUntilEndOfDayLocal = (): number => {
	const now = new Date();
	const endOfDay = new Date(now);
	endOfDay.setHours(23, 59, 59, 999);
	return Math.max(0, endOfDay.getTime() - now.getTime());
};

export const dismissBannerUntilEOD = (storageKey: StorageKey) => {
	const timeToLiveInMs = getMsUntilEndOfDayLocal();
	const record: BannerDismissRecord = {
		dismissedAtMs: Date.now(), // when user clicked X
		expiresAtMs: Date.now() + timeToLiveInMs, // when banner may reappear
	};
	localStorage.setItem(storageKey, JSON.stringify(record));
};

export const isBannerDismissed = (storageKey: StorageKey): boolean => {
	try {
		const raw = localStorage.getItem(storageKey);
		if (!raw) {
			return false;
		}
		const result = BannerDismissRecordSchema.safeParse(JSON.parse(raw));
		if (!result.success) {
			localStorage.removeItem(storageKey);
			return false;
		}
		const { expiresAtMs } = result.data;

		if (Date.now() >= expiresAtMs) {
			localStorage.removeItem(storageKey);
			return false;
		}
		return true;
	} catch {
		return false;
	}
};
